export const convertDateTimeFormat = (dateTimeStr) => {
    const date = new Date(dateTimeStr);

    if (isNaN(date.getTime())) return '';

    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12;
    hours = hours ? hours : 12;

    const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
    const formattedSeconds = seconds < 10 ? '0' + seconds : seconds;

    return `${month}/${day}/${year}, ${hours}:${formattedMinutes}:${formattedSeconds} ${ampm}`;
};
